<template>
  <div class="content has-text-centered">
    <div class="columns is-vcentered">
      <div class="column is-6 is-offset-3">
        <div class="box">
          <form v-on:submit.prevent="register">
            <label class="label">Email</label>
            <p class="control">
                <input id="email" v-model="data.body.username" class="input" type="email" placeholder="email@example.org">
            </p>
            <label class="label">Password</label>
            <p class="control">
              <input v-model="data.body.password" class="input" type="password" placeholder="password">
            </p>
            <label class="label">Match password</label>
            <p class="control">
              <input v-model="data.matchPassword" class="input" type="password" placeholder="match password">
            </p>
<!--            <label class="label">Идентификатор партнера/реферера</label>-->
<!--            <p class="control">-->
<!--              <input v-model="data.body.mainUserId" class="input" type="text" placeholder="Идентификатор">-->
<!--            </p>-->
            <div v-if="!rcapt_disable" class="g-recaptcha" :data-sitekey="rcapt_sig_key" id="g-recaptcha"></div>
            <hr>
            <p class="control">
              <button v-if="canSignUp" type="submit" class="button is-primary">Зарегистрироваться</button>
              <a href="#/login" class="button is-success">
                <span>Войти</span>
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import AuthCommon from './AuthCommon'

  const APPCONFIG_API = '/api/appConfig'
  const AUTH_API = '/api/auth'

  export default {
    extends: AuthCommon,
    data() {
      return {
        data: {
          body: {
            username: null,
            password: null,
            role: 16,
            // mainUserId: null,
            recaptchaResponse: null
          },
          matchPassword: null,
          rememberMe: false
        },
        rcapt_sig_key: process.env.GOOGLE_RECAPTCHA_KEY,
        rcapt_disable: process.env.CAPTCHA_DISABLED,
        rcapt_id: 0,
        canSignUp: true,
        reg: /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/
      }
    },
    mounted() {
      if (window.grecaptcha && !this.rcapt_disable) {
        this.rcapt_id = grecaptcha.render(document.getElementById('g-recaptcha'), { sitekey : this.rcapt_sig_key })
      }
    },
    created: function () {
      this.loadAppConfig()
    },
    methods: {
      ...mapActions([
        'setAuthenticationToken',
        'setLoggedRole',
        'setLoggedStatus',
        'setLoggedId'
      ]),
      register() {
        if (this.validateFields()) {
          this.$http.post(AUTH_API + '/sign-up', this.data.body)
            .then((response) => {
              this.openNotificationWithType('success', 'Успешная регистрация пользователя ' + this.data.body.username)
              this.loginCallback(response)
              this.$router.push('/scenarios')
            })
            .catch((error) => {
              this.openNotificationWithType('danger', 'Ошибка регистрации' + '\n' + error.response.data)
              console.log(error.response.data)
            })
        }
      },
      validateFields() {
          if (this.data.body.username) {
            if (this.reg.test(this.data.body.username)) {
              if (this.data.matchPassword === this.data.body.password) {
                if (!this.rcapt_disable && grecaptcha) {
                  this.data.body.recaptchaResponse = grecaptcha.getResponse(this.rcapt_id)
                  if (this.data.body.recaptchaResponse) {
                    return true
                  } else {
                    this.openNotificationWithType('danger', 'Необходимо пройти капчу!')
                  }
                } else {
                  return true
                }
              } else {
                this.openNotificationWithType('danger', 'Пароли не совпадают')
              }
            } else {
              this.openNotificationWithType('danger', 'Необходимо ввести корректный адрес электронной почты')
            }
          } else {
            this.openNotificationWithType('danger', 'Необходимо ввести адрес электронной почты')
          }
          return false
      },
      loadAppConfig () {
        this.$http.get(APPCONFIG_API, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.appconfig = response.data
            this.canSignUp = this.appconfig.userCanSignUp
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }
</style>



// WEBPACK FOOTER //
// SignUp.vue?4a8b8f6c